import { IconProps } from '@/modules/defines/interface';

const Escalator = ({ fill, width, height }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '32'}
      height={height || '32'}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6094 6.5052C20.3593 5.75509 21.3765 5.33357 22.4372 5.33334H26.0002C27.2378 5.33334 28.4248 5.82501 29.3 6.70018C30.1752 7.57535 30.6668 8.76233 30.6668 10C30.6668 11.2377 30.1752 12.4247 29.3 13.2998C28.4248 14.175 27.2378 14.6667 26.0002 14.6667H24.5524L13.7244 25.4947C13.7244 25.4947 13.7245 25.4946 13.7244 25.4947C12.9745 26.2448 11.9572 26.6665 10.8964 26.6667H6.00016C4.76249 26.6667 3.5755 26.175 2.70033 25.2998C1.82516 24.4247 1.3335 23.2377 1.3335 22C1.3335 20.7623 1.82516 19.5753 2.70033 18.7002C3.5755 17.825 4.76249 17.3333 6.00016 17.3333H8.78121L19.6094 6.5052C19.6094 6.50515 19.6093 6.50525 19.6094 6.5052ZM22.4375 8.00001C22.084 8.00016 21.745 8.14068 21.4951 8.39068L10.2763 19.6095C10.0263 19.8595 9.68712 20 9.3335 20H6.00016C5.46973 20 4.96102 20.2107 4.58595 20.5858C4.21088 20.9609 4.00016 21.4696 4.00016 22C4.00016 22.5304 4.21088 23.0392 4.58595 23.4142C4.96102 23.7893 5.46973 24 6.00016 24H10.8959C10.8958 24 10.896 24 10.8959 24C11.2494 23.9999 11.5886 23.8593 11.8385 23.6093L23.0574 12.3905C23.3074 12.1405 23.6465 12 24.0002 12H26.0002C26.5306 12 27.0393 11.7893 27.4144 11.4142C27.7894 11.0392 28.0002 10.5304 28.0002 10C28.0002 9.46958 27.7894 8.96087 27.4144 8.5858C27.0393 8.21072 26.5306 8.00001 26.0002 8.00001H22.4375C22.4376 8.00001 22.4374 8.00001 22.4375 8.00001Z"
        fill={fill}
      />
    </svg>
  );
};

export default Escalator;
